import CommonFieldDataUtils from '../common/CommonFieldDataUtils';
import ICompLocalVersion, { newCompLocalVersion } from './ICompLocalVersion';

export default {
    duplicate(localVersion: ICompLocalVersion): ICompLocalVersion {
        const result = newCompLocalVersion();
        result.propertyPhoto = localVersion.propertyPhoto;
        result.fieldData = CommonFieldDataUtils.duplicate(localVersion.fieldData);
        return result;
    }
};
